import { render, staticRenderFns } from "./ModalShowBadge.vue?vue&type=template&id=47972c62&scoped=true&lang=pug&"
import script from "./ModalShowBadge.vue?vue&type=script&lang=ts&"
export * from "./ModalShowBadge.vue?vue&type=script&lang=ts&"
import style0 from "./ModalShowBadge.vue?vue&type=style&index=0&id=47972c62&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47972c62",
  null
  
)

export default component.exports